module.exports = __webpack_public_path__ + "img/service-after-content-one@3x.085f8e5f.png";